import { render, staticRenderFns } from "./ParcelsMap.vue?vue&type=template&id=03934088&"
import script from "./ParcelsMap.vue?vue&type=script&lang=js&"
export * from "./ParcelsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports